import React, { useState, useEffect, Suspense, useContext } from 'react';
import clsx from 'clsx';
import stylesPaymentHistory from './paymenthistory.module.css';
import styleGlobal from '../../styles/referral/global.module.css'
import { formatTimestampSeprate, formatTimestampWithOutComma } from '../../utils/DateTimings';
import { PaymentCardsProps } from '../../utils/CommonType';

import paymentHistoryImage from '../../assets/images/referral/paymentIcon.png';
import { usePassbookApiNextContent, useTranscationHistoryFilters } from '../../api/passbook';
import Loader from '../Loader';
import CalenderContext from '../../context/CalenderContext';
import TransactionHistoryContext, { defaultPayloadDataState} from '../../context/TransactionHistory';
import { useTokenStore } from '../../storage/tokenState';
import InnerLoader from '../InnerLoader';



const PaymentCardsFullLayout: React.FC<PaymentCardsProps> = ({checkScroll}) => {

    const [cardType, setCardType] = useState<string>('All');
    //const [transactionsHistory, setTransactionsHistory] = useState<any[]>([]);
    const {startDate, endDate} = useContext(CalenderContext);
    const { token } = useTokenStore();

    const {PayloadDataState, setPayloadDataState, setTabChange, transactionHistoryFilters, transactionHistory, activeTab, setActiveTab, loadMore, setLoadMore, walletLastSelectedItemState, walletLastSelectedTimeState, loading, remainCount, setLoading} = useContext(TransactionHistoryContext);

    const { filterFunction } = useTranscationHistoryFilters();
    const { nextContentFunction } = usePassbookApiNextContent();
 

    const refetchPassbookData = async () => {
        await setTabChange(true);
       // await refetchPassbook();
    }

     useEffect(() => {
        if(transactionHistoryFilters){
             if(activeTab === null){
                 setActiveTab(transactionHistoryFilters?.response?.items[0]?.defaultSelected[0]);
             }
         }
     }, [transactionHistoryFilters]);

    const updatePassbookDataAsync = async (transactionHistory: any) => {
       // if (transactionHistory) {
            //let transactions = await passbookData?.pages?.map((page: any) => page?.response?.data?.transactions);
            // Sort the transactions immediately when setting state
           await transactionHistory?.sort((a: any, b: any ) => {
              let timestampA = a.timestamp;
              let timestampB = b.timestamp;
              return timestampB > timestampA ? 1 : -1; // default descending
            });
           // await setTransactionsHistory(transactions.flat());
         // }
          //console.log("passbookData", transactionHistory);
    }

     useEffect(() => {
        // updatePassbookDataAsync(transactionHistory);
       }, [transactionHistory]);

    const handelActiveTab = async (type: string, displayName: string) => {
       // const { count } = defaultPayloadDataState;
    //    await setTabChange(true);
        const {
             walletLastSelectedItem,
             walletLastSelectedTime,
            // dateFilter,
             ...cleanedState
           } = PayloadDataState;
           const newPayload = { ...cleanedState, filterCodes: [type] };
        await setLoadMore(false);
        await setPayloadDataState(newPayload);
         setActiveTab(type);
         setCardType(displayName);
    //     refetchPassbookData();
    }

    useEffect(() => {
        if((startDate && endDate) && (startDate.getTime() <= endDate.getTime())){
            const dateFilter = {
                startTime: startDate.getTime(),
                endTime: endDate.getTime()
            }
            setPayloadDataState({...PayloadDataState, dateFilter: dateFilter});
        }
    }, [startDate, endDate]);


    useEffect(() => {
        nextContentFunction();
    }, [PayloadDataState]);

    useEffect(() => {
        filterFunction();
    }, [token]);

     const loadMoreHandler = async () => {
        await setLoadMore(true);
        setLoading(true);
        await setPayloadDataState({...PayloadDataState, walletLastSelectedItem: walletLastSelectedItemState, walletLastSelectedTime: walletLastSelectedTimeState});
        //await nextContentFunction();
     }

    return (
        <>
         <div className={clsx(stylesPaymentHistory.paymentCard)}>
            <div className={clsx(stylesPaymentHistory.tabContainer, 'mb20', stylesPaymentHistory.chipsticky)}>
             <Suspense fallback={<Loader />}>
            {
                  transactionHistoryFilters?.response?.items[0]?.filters.map((item: any) => {
                     if(item.code){
                        return <div key={item.code} className={clsx(stylesPaymentHistory.tabItem, 'fontSizeSm12', 'fontWeightMedium', activeTab === item.code ? stylesPaymentHistory.active : '')} onClick={()=>handelActiveTab(item.code, item.displayName)}> {item.displayName}</div>
                     }
                 })
                }
                </Suspense>
            </div>
            {loading  && <InnerLoader/>}
             { transactionHistory?.length > 0 ? (
                transactionHistory.map((item: any)   => {
                    
                return <div className={clsx(stylesPaymentHistory.paymentCardBody, 'mt20', 'mb20', `tid-${item?.tid}`)} key={item?.tid}>
                    <div className={clsx(stylesPaymentHistory.paymentCardBodyHeader)}>
                        <div className={clsx(stylesPaymentHistory.paymentCardBodyFirstColumn)}>
                            <div className={clsx(stylesPaymentHistory.paymentCardBodyImage, styleGlobal.flex1)}>
                                <img src={item?.icon ? item?.icon : paymentHistoryImage} alt={item?.tid} />
                            </div>
                            <div className={clsx(stylesPaymentHistory.paymentCardBodyText, styleGlobal.flex6)}>
                                <span className={clsx('fontSizeSm14', 'fontWeightBold')}>{item?.transactionHeaderDisplayText}</span>
                                {item?.transactionLabel.map((label: any, indexChip: number)=>{
                                    return label.showChip ?  <span key={indexChip} className={clsx(stylesPaymentHistory.paymentCardBodySuccessMessage, 'fontSize8', 'fontWeightNormal', 'textUppercase', stylesPaymentHistory.success)} style={{backgroundColor: label['chipBackgroundColor'], color: '#fff'}}>
                                    <span>{label['displayText']}</span>
                                </span> : <span key={indexChip} className={clsx(stylesPaymentHistory.paymentCardBodySuccessMessage, 'fontSize8', 'fontWeightNormal', 'textUppercase', stylesPaymentHistory.unsuccess)}>
                                    <span>{label['displayText']}</span>
                                </span>
                                })}
                            </div>
                            <div className={clsx(stylesPaymentHistory.paymentCardBodyAmount, styleGlobal.flex3)}>
                                <span className={clsx(stylesPaymentHistory.paymentCardBodyAmountText, 'fontSizeSm14', 'fontWeightBold')}>
                                      {item?.amount}
                                    </span>
                                <span className={clsx('fontSizeXs', 'fontWeightNormal', 'wimg100', 'flex', 'justifyContentFE')}>{formatTimestampSeprate(new Date(item?.timestamp).getTime())}</span>
                            </div>
                        </div>
                        
                    </div>
                   </div>
            }) ) : (
                <div className={clsx(stylesPaymentHistory.paymentCardBody, 'mt20', 'mb20')}>
                    <div className={clsx(stylesPaymentHistory.paymentCardBodyHeader)}>
                        <div className={clsx(stylesPaymentHistory.paymentCardBodyFirstColumn)}>
                            <span className={clsx('fontSizeSm14', 'fontWeightBold')}>No transactions found</span>
                        </div>
                    </div>
                </div>
            )}
             
            {(remainCount >= PayloadDataState.count) && <button className={clsx(stylesPaymentHistory.paymentButtonInner, stylesPaymentHistory.paymentBoxBorder, 'flex1', 'fontSizeSm14', 'fontWeightBold',styleGlobal.ptbl10)} onClick={loadMoreHandler}>Load More</button>}
        </div> 
        
        </>
  )
}

export default PaymentCardsFullLayout;